const $ = jQuery;

export function better_wpcf7_forms() {
  $( '.wpcf7 .wpcf7-submit' ).each( function ( this: HTMLButtonElement ) {
    // Move ajax loader before submit button
    $( this ).find( '+ .ajax-loader' ).insertBefore( this );
    // Change submit input to a button instead
    var submitHTML = this.outerHTML;
    var submitValue = this.value;
    submitHTML = submitHTML.replace( /^<input /, '<button ' );
    submitHTML = submitHTML.replace( /\/?>$/, '>' + submitValue + '</button>' );
    $( this ).replaceWith( submitHTML );
  } );
}

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('input[type="file"]').forEach(function(fileInput) {
      fileInput.addEventListener('change', function() {
          let file = (fileInput as HTMLInputElement).files?.[0]; // Added null check
          if (file) {
              let filename = file.name;
              console.log(filename);
              let descriptionElement = fileInput.parentElement?.querySelector('.gfield_description'); // Added null check
              if (descriptionElement) {
                  descriptionElement.textContent = filename;
              }
          }
      });
  });
  document.querySelectorAll<HTMLSelectElement>('.gv-search-box select').forEach((select) => {
      select.addEventListener('change', () => {
          const submit = document.querySelector<HTMLInputElement>('.gv-search-box-submit input[type="submit"]');
          submit?.click();
      });
  });
});
